<template>
  <div>
    <base-header class="pb-6" type>
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Enrolled courses')"></breadcrumbs>
      </div>
    </base-header>

    <v-wait for="student-course-fetching">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div v-if="courses" class="row">
          <div v-for="(course, index) in courses" :key="index" class="col col-md-4">
            <card>
              <!-- Card image -->
              <img
                v-if="course.mediaUrl"
                class="card-img-top"
                :src="course.mediaUrl"
                alt="Image placeholder"
              />

              <template v-else>
                <span v-html="course.svg"></span>
              </template>
              <!-- Card body -->
              <div class="card-body">
                <h5 class="h2 card-title mb-0">{{course.title}}</h5>
                <p class="card-text mt-4">{{course.description}}</p>
                <router-link :to="{name: 'learn-course-content', params: {courseId: course.name}}">
                  <base-button>{{ $t('Go To Course') }}</base-button>
                </router-link>
              </div>
            </card>
          </div>
        </div>
        <div v-else>
          <h2>Вы не (выбрали/оплатити) ни одного курса</h2>
        </div>
        <div v-if="isAuthor">
          <h2>Ваши авторские курсы</h2>
        </div>
        <div class="row" v-if="authorCourses">
          <div v-for="(course, index) in authorCourses" :key="index" class="col col-md-4">
            <card>
              <!-- Card image -->
              <img
                v-if="course.mediaUrl"
                class="card-img-top"
                :src="course.mediaUrl"
                alt="Image placeholder"
              />

              <template v-else>
                <span v-html="course.svg"></span>
              </template>
              <!-- Card body -->
              <div class="card-body">
                <h5 class="h2 card-title mb-0">{{course.title}}</h5>
                <p class="card-text mt-4">{{course.description}}</p>
                <router-link :to="{name: 'learn-course-content', params: {courseId: course.name}}">
                  <base-button>{{ $t('Go To Course') }}</base-button>
                </router-link>
              </div>
            </card>
          </div>
        </div>
      </div>

    </v-wait>
  </div>
</template>
<script>
import Breadcrumbs from "../../Layout/Breadcrumbs.vue";
import { Table, Tooltip, TableColumn } from "element-ui";
import Spinner from "vue-spinner-component/src/Spinner.vue";

export default {
  name: "CourseList",
  metaInfo() {
    return {
      title: this.$i18n.t("Course list"),
    };
  },
  components: {
    Breadcrumbs,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Spinner,
  },
  created() {
    this.fetchData();
  },
  computed: {
    courses() {
      return this.$store.getters['student/course/getCourses'];
    },
    authorCourses() {
      return this.$store.getters['course/getCourses'];
    },
    isAuthor(){
      return this.$store.getters['auth/isAuthor']
    }
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    async fetchData() {
      this.$wait.start("student-course-fetching");
      await this.$store.dispatch("student/course/loadCourses");
      await this.$store.dispatch("course/loadCourses");
      this.$wait.end("student-course-fetching");
    },
  },
};
</script>
<style></style>
